import { useEffect } from 'react'

interface MetaTagsConfig {
  title: string
  description: string
  keywords?: string
  ogTitle?: string
  ogDescription?: string
  ogType?: string
  ogImage?: string
  canonical?: string
  author?: string
}

function setMetaTag(name: string, content: string, attribute: string = 'name') {
  let element = document.querySelector(
    `meta[${attribute}="${name}"]`,
  ) as HTMLMetaElement | null
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, name)
    document.head.appendChild(element)
  }
  element.setAttribute('content', content)
}

export function useMetaTags({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogType = 'website',
}: MetaTagsConfig) {
  useEffect(() => {
    // Page title
    document.title = title

    // Standard meta tags
    setMetaTag('description', description)
    if (keywords) {
      setMetaTag('keywords', keywords)
    }

    // Open Graph tags
    setMetaTag('og:title', ogTitle || title, 'property')
    setMetaTag('og:description', ogDescription || description, 'property')
    setMetaTag('og:type', ogType, 'property')

    // Twitter card tags
    setMetaTag('twitter:card', 'summary_large_image')
    setMetaTag('twitter:title', ogTitle || title)
    setMetaTag('twitter:description', ogDescription || description)

    // Robots
    setMetaTag('robots', 'index, follow')
  }, [title, description, keywords, ogTitle, ogDescription, ogType])
}
